import axios from "axios";
import {API_CONFIG} from "../config/api_config";
import LuissState from "./luiss_state";
import {computeBackendPath} from "../containers/page_dispatcher/page_dispatcher";
import {HIGH_LEVEL_CONFIG} from "../config/high_level_config";
import {BreadcrumbPiece} from "../utils/menu";


export const ACTIONS = {

    PAGES_MAPPING_LOADED: 'PAGES_MAPPING_LOADED',
    PAGES_MAPPING_LOADING: 'PAGES_MAPPING_LOADING',
    CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
    CHANGE_BASE_COLOR: 'CHANGE_BASE_COLOR',
    CHANGE_BREADCRUMB: 'CHANGE_BREADCRUMB',

    changeLanguage: (language: string) => {
        return changeLanguage(language);
    },

    changeLanguageState: (language: string) => ({
        type: ACTIONS.CHANGE_LANGUAGE,
        language: language
    }),

    pagesMappingLoaded: (mapping: Map<string, string>) => ({
        type: ACTIONS.PAGES_MAPPING_LOADED,
        mapping: mapping,
        mapping_age: new Date().getTime()
    }),

    pagesMappingLoading: (language: string) => {
        return getRequestMapping(language);
    },

    changeBaseColor: (color: string) => ({
        type: ACTIONS.CHANGE_BASE_COLOR,
        color: color
    }),

    changeBreadcrumb: (breadcrumb: BreadcrumbPiece[]) => ({
        type: ACTIONS.CHANGE_BREADCRUMB,
        breadcrumb: breadcrumb
    })
};


function changeLanguage(language: string) {
    return (dispatch: (action: {type: string}) => any, getState: () => LuissState) => {

        if (language === 'zh') {
            window.location.href = "https://" + HIGH_LEVEL_CONFIG.CHINESE_DOMAIN;
        } else {

            let state = getState();

            let backendPath = state.router.location.pathname;

            if (state.app.mapping) {
                let mapping = new Map(Object.entries(state.app.mapping));
                backendPath = computeBackendPath(state.router.location.pathname, mapping);
            }

            if (language === 'en') {
                window.location.href = "https://" + HIGH_LEVEL_CONFIG.ENGLISH_DOMAIN + backendPath + window.location.search;
            } else {
                window.location.href = "https://" + HIGH_LEVEL_CONFIG.ITALIAN_DOMAIN + backendPath + window.location.search;
            }
        }
    };
}


function getRequestMapping(language: string) {

    return async function(dispatch: (action: {type: string}) => any) {

        try {
            const response = await axios.get(API_CONFIG.BASE_URL + API_CONFIG.PAGES_MAPPING_PATH + "/" + language);
            if (response.status < 300) {

                //const mapping = new Map(Object.entries(response.data));
                let data: any;
                // If the response is a string, it means it can't be parsed
                if (response.data && response.data.replace && response.data.trim) {
                    data = JSON.parse(response.data.replace("The website encountered an unexpected error. Please try again later.<br />", "").trim());
                } else {
                    data = response.data;
                }
                dispatch(ACTIONS.pagesMappingLoaded(data));

            } else {
                console.warn("[WARNING]: Cannot load the pages' mapping");
                console.log(response);

                // if we cannot retrieve the mapping, we try to use an empty mapping
                dispatch(ACTIONS.pagesMappingLoaded(new Map<string, string>()))
            }

        } catch (e) {
            console.warn("[WARNING]: Data retrieve failed for pages mapping", e);

        }
    }
}
